module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-114x114-3ecd5bdd7929dc9a15f6e53bbe18b2a6.png";